 const arrayMove = (arr?: any[], oldIndex?: number, newIndex?: any) => {
  let tempArr = [];
  if (newIndex >= arr.length) {
    let i = newIndex - arr.length + 1;
    while (i--) {
      arr.push(undefined);
    }
  }

  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

  arr.forEach((elm) => tempArr.push(elm));

  return tempArr;
};

export default arrayMove;
